// extracted by mini-css-extract-plugin
export default {"title-wrapper":"EpXuM8","titleWrapper":"EpXuM8","done":"WRz9C2","collapsed":"kF5tqo","title":"Dot02V","checkmark":"Vvv9D6","textButton":"TMKWWc"};